/* Exportações em CSV a partir das rotas de análise. */

import { api } from '../../core/api';
import { baixarCSV } from '../../core/arquivos';
import { state } from '../../core/estado';
import { lista, num } from '../../core/formato';
import type { Lancamento, Mes, PorCategoria, PorMaterial, PorObra } from '../../tipos/api';
import { paramsFiltro } from '../../ui/filtros';
import { toast } from '../../ui/toast';

async function exportar(fn: () => Promise<void>): Promise<void> {
  try {
    await fn();
  } catch (e) {
    toast((e as Error).message);
  }
}

export const exportarMensal = () => exportar(async () => {
  const d = lista<Mes>(await api('GET', '/mensal', { params: paramsFiltro() }));
  baixarCSV(`emissoes_mensais_${state.f.ano}.csv`, [
    ['mes', 'escopo_1_tco2e', 'escopo_2_tco2e', 'escopo_3_tco2e', 'total_tco2e'],
    ...d.map((m) => [m.mes, num(m.escopo_1), num(m.escopo_2), num(m.escopo_3), num(m.total_emissoes)]),
  ]);
});

export const exportarObras = () => exportar(async () => {
  const d = lista<PorObra>(await api('GET', '/por-obra', { params: paramsFiltro() }));
  baixarCSV(`emissoes_por_obra_${state.f.ano}.csv`, [
    ['obra', 'escopo_1_tco2e', 'escopo_2_tco2e', 'escopo_3_tco2e', 'total_tco2e'],
    ...d.map((u) => [u.unidade_negocio || '', num(u.escopo_1), num(u.escopo_2), num(u.escopo_3), num(u.total_emissoes)]),
  ]);
});

export const exportarCategorias = () => exportar(async () => {
  const d = lista<PorCategoria>(await api('GET', '/por-categoria', { params: paramsFiltro() }));
  baixarCSV(`emissoes_por_categoria_${state.f.ano}.csv`, [
    ['categoria', 'escopo', 'lancamentos', 'total_tco2e'],
    ...d.map((c) => [c.categoria_de_emissoes || '', c.escopo || '', num(c.quantidade_registros), num(c.total_emissoes)]),
  ]);
});

export const exportarMateriais = () => exportar(async () => {
  const d = lista<PorMaterial>(await api('GET', '/por-material', { params: paramsFiltro() }));
  if (!d.length) return toast('Nenhuma compra de material lançada no ano selecionado.');
  baixarCSV(`materiais_comprados_${state.f.ano}.csv`, [
    ['material', 'quantidade', 'unidade', 'valor_total_reais', 'lancamentos', 'total_tco2e'],
    ...d.map((m) => [m.material || '', num(m.quantidade), m.unidade || '', num(m.valor_total), num(m.quantidade_registros), num(m.total_emissoes)]),
  ]);
});

export const exportarLancamentos = () => exportar(async () => {
  const d = lista<Lancamento>(await api('GET', '/lancamentos', { params: { ...paramsFiltro(), limite: 5000 } }));
  if (!d.length) return toast('Nenhum lançamento no ano selecionado.');
  baixarCSV(`lancamentos_${state.f.ano}.csv`, [
    ['data', 'obra', 'escopo', 'categoria', 'categoria_geral', 'descricao', 'cnpj_fornecedor', 'co2_t', 'ch4_t', 'n2o_t', 'total_tco2e', 'co2_biogenico_t'],
    ...d.map((l) => [l.data, l.obra || '', l.escopo || '', l.categoria || '', l.categoria_geral || '', l.descricao || '', l.cnpj_fornecedor || '',
      num(l.co2), num(l.ch4), num(l.n2o), num(l.total), num(l.biogenica)]),
  ]);
});
